module.exports = __webpack_public_path__ + "static/media/Home_Background_Particles.0796a7a5.svg";